import React, { useCallback } from 'react';

import { track } from '@betterment/js-runtime';
import { Box, Flex, theme } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

import CloseButton from './CloseButton';
import Wordmark from './Wordmark';

const HEIGHT = theme.space[11];

const TakeoverHeaderBase = styled(Flex)`
  height: ${HEIGHT};
  min-height: ${HEIGHT};
`;

const Title = styled.div`
  font-size: ${theme.fontSizes[0]};
  line-height: ${theme.lineHeights[0]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${theme.colors.bmtGrey50};
`;

interface Props {
  title: string;
  closeHandler?: () => void;
}

const TakeoverHeader: React.FC<React.PropsWithChildren<Props>> = ({ title, closeHandler }) => {
  const trackClick = useCallback(() => {
    track('ElementClicked', { name: 'SignupHeader' });
  }, []);

  return (
    <TakeoverHeaderBase onClick={trackClick} alignItems="center">
      <Flex alignItems="center">
        <Wordmark />
      </Flex>
      <Box
        ml={[3, 6]}
        pl={[3, 6]}
        pr="8"
        borderLeft={`1px solid ${theme.colors.bmtGrey20 as string}`}
        overflow="hidden"
      >
        <Title>{title}</Title>
      </Box>
      {closeHandler && <CloseButton closeHandler={closeHandler} />}
    </TakeoverHeaderBase>
  );
};

export default TakeoverHeader;
